/**
 * Le dernier projet où le + a mis quelque chose (chantier `telephone-projets-fiche`, ticket 05,
 * décision d'Igor du 2026-10-05, revue 20 : « une tâche dans le dernier projet utilisé
 * (changeable) »). Une commodité de cet appareil : gardée dans le navigateur, jamais au serveur ;
 * si le navigateur refuse (navigation privée, stockage bloqué), le + propose le premier projet.
 */

const CLE = 'nextilt-dernier-projet';

export function lireLeDernierProjet(): string | null {
  try {
    return window.localStorage.getItem(CLE);
  } catch {
    return null;
  }
}

export function garderLeDernierProjet(id: string): void {
  try {
    window.localStorage.setItem(CLE, id);
  } catch {
    // Rien à garder : la prochaine fois, le premier projet.
  }
}
